(function () {
  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function compactMoney(cents) {
    var value = Number(cents) || 0;
    return money(Math.round(value / 100) * 100).replace(/\.00(?=\D*$)/, '');
  }

  function initGallery(root) {
    var image = root.querySelector('[data-product-main-image]');
    if (!image) return;
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-media-src]'));

    function show(index) {
      if (!buttons.length) return;
      index = (index + buttons.length) % buttons.length;
      var button = buttons[index];
      image.src = button.dataset.mediaSrc;
      image.removeAttribute('srcset');
      buttons.forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        show(index);
      });
    });

    var previous = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', function () { show(buttons.findIndex(function (item) { return item.classList.contains('is-active'); }) - 1); });
    if (next) next.addEventListener('click', function () { show(buttons.findIndex(function (item) { return item.classList.contains('is-active'); }) + 1); });
  }

  function initProduct(root) {
    var form = root.querySelector('[data-product-form]');
    var json = root.querySelector('[data-product-variants]');
    if (!form || !json) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }

    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-group]'));
    var price = form.querySelector('[data-product-price]');
    var compare = form.querySelector('[data-product-compare]');
    var savings = form.querySelector('[data-product-savings]');
    var submit = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-product-error]');
    var bundleButtons = Array.prototype.slice.call(form.querySelectorAll('[data-bundle-count]'));
    var fourPillowGift = form.querySelector('[data-four-pillow-gift]');

    function selectedOptions() {
      return groups.map(function (group) {
        var selected = group.querySelector('[data-option-value].is-selected');
        return selected ? selected.dataset.optionValue : '';
      });
    }

    function syncVariant() {
      var options = selectedOptions();
      var variant = variants.find(function (item) {
        return item.options.every(function (value, index) { return value === options[index]; });
      });
      if (!variant) return;
      form.dataset.selectedVariantId = String(variant.id);
      price.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = money(variant.compare_at_price);
        if (savings) {
          var savingsAmount = variant.compare_at_price - variant.price;
          var savingsPercent = Math.round((savingsAmount / variant.compare_at_price) * 100);
          savings.hidden = false;
          savings.textContent = savingsPercent + '% OFF · Save ' + compactMoney(savingsAmount);
        }
      } else {
        compare.hidden = true;
        if (savings) savings.hidden = true;
      }
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? submit.dataset.submitText : 'SOLD OUT';

      var firstThumb = root.querySelector('[data-media-src]');
      if (firstThumb && variant.featured_image && variant.featured_image.src) {
        firstThumb.dataset.mediaSrc = variant.featured_image.src;
        var firstThumbImage = firstThumb.querySelector('img');
        if (firstThumbImage) firstThumbImage.src = variant.featured_image.src;
        if (firstThumb.classList.contains('is-active')) {
          var selectedImage = root.querySelector('[data-product-main-image]');
          if (selectedImage) {
            selectedImage.src = variant.featured_image.src;
            selectedImage.removeAttribute('srcset');
          }
        }
      }

      bundleButtons.forEach(function (button) {
        var bundle = variants.find(function (item) {
          return item.options[0] === options[0] && item.options[1] === button.dataset.optionValue;
        });
        if (!bundle) return;
        var count = Number(button.dataset.bundleCount) || 1;
        var bundlePrice = button.querySelector('[data-bundle-price]');
        var bundleCompare = button.querySelector('[data-bundle-compare]');
        var bundleUnit = button.querySelector('[data-bundle-unit]');
        var ribbon = button.querySelector('[data-bundle-ribbon]');
        button.disabled = !bundle.available;
        if (bundlePrice) bundlePrice.textContent = money(bundle.price);
        if (bundleCompare) {
          bundleCompare.hidden = !(bundle.compare_at_price && bundle.compare_at_price > bundle.price);
          bundleCompare.textContent = money(bundle.compare_at_price);
        }
        if (bundleUnit) bundleUnit.textContent = money(Math.round(bundle.price / count)) + '/each';
        if (ribbon) {
          var label = count === 2 ? 'MOST POPULAR' : 'BEST DEAL';
          var bundleSavings = bundle.compare_at_price && bundle.compare_at_price > bundle.price ? bundle.compare_at_price - bundle.price : 0;
          ribbon.textContent = label + (bundleSavings ? ' · Save ' + compactMoney(bundleSavings) : '');
        }
      });

      var selectedBundle = form.querySelector('[data-bundle-count].is-selected');
      if (fourPillowGift) fourPillowGift.classList.toggle('is-unlocked', selectedBundle && Number(selectedBundle.dataset.bundleCount) === 4);
    }

    groups.forEach(function (group) {
      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          group.querySelectorAll('[data-option-value]').forEach(function (item) { item.classList.remove('is-selected'); });
          button.classList.add('is-selected');
          syncVariant();
        });
      });
    });

    form.querySelectorAll('.rc-gift-card input').forEach(function (input) {
      input.addEventListener('change', function () {
        input.closest('.rc-gift-card').classList.toggle('is-selected', input.checked);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      errorBox.hidden = true;
      submit.disabled = true;
      submit.querySelector('span').textContent = 'ADDING…';

      var items = [{ id: Number(form.dataset.selectedVariantId), quantity: 1 }];
      if (root.dataset.addGifts === 'true') {
        form.querySelectorAll('[data-gift-variant]:checked').forEach(function (input) {
          if (input.dataset.giftVariant) items.push({ id: Number(input.dataset.giftVariant), quantity: 1, properties: { _rc_offer: 'Free gift' } });
        });
      }
      var upsell = form.querySelector('[data-upsell-variant]:checked');
      if (upsell && upsell.dataset.upsellVariant) items.push({ id: Number(upsell.dataset.upsellVariant), quantity: 1, properties: { _rc_offer: 'Complete the set' } });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (payload) { throw new Error(payload.description || 'Unable to add this offer to cart.'); });
        return response.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (root.dataset.redirect === 'checkout') window.location.href = '/checkout';
        else if (root.dataset.redirect === 'cart') window.location.href = '/cart';
        else {
          submit.disabled = false;
          submit.querySelector('span').textContent = 'ADDED TO CART';
          setTimeout(function () { submit.querySelector('span').textContent = submit.dataset.submitText; }, 1800);
        }
      }).catch(function (error) {
        errorBox.textContent = error.message;
        errorBox.hidden = false;
        submit.disabled = false;
        submit.querySelector('span').textContent = submit.dataset.submitText;
      });
    });

    syncVariant();
    initGallery(root);
  }

  function initUgc(section) {
    var track = section.querySelector('[data-ugc-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(section.querySelectorAll('.rc-ugc__dots i'));
    if (!track || !cards.length) return;

    function update() {
      var cardWidth = cards[0].getBoundingClientRect().width + 14;
      var index = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / cardWidth)));
      dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
    }

    var previous = section.querySelector('[data-ugc-prev]');
    var next = section.querySelector('[data-ugc-next]');
    if (previous) previous.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * .82, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
  }

  function initStickyBuy() {
    var sticky = document.querySelector('[data-sticky-buy]');
    var product = document.querySelector('[data-rc-product]');
    if (!sticky || !product || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.scrollY > 500);
    }, { threshold: .05 });
    observer.observe(product);
  }

  function init() {
    document.body.classList.add('rc-ksp-page');
    document.querySelectorAll('[data-rc-product]').forEach(initProduct);
    document.querySelectorAll('.rc-ugc').forEach(initUgc);
    initStickyBuy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
